import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import ContactModal from './ContactModal';

export default function CTASection() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [defaultDemo, setDefaultDemo] = useState(false);

  const openContactModal = (withDemo = false) => {
    setDefaultDemo(withDemo);
    setIsContactOpen(true);
  };

  return (
    <>
      <section className="py-32 px-6 lg:px-12 bg-gradient-to-b from-white via-gray-50/50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-light tracking-tight text-gray-900 mb-6">
            See how Longfloat fits your workflow
          </h2>
          <p className="text-lg text-gray-600 font-light max-w-2xl mx-auto mb-10 leading-relaxed">
            Schedule a personalized demo to see how teams like yours are using Longfloat or talk to our team about your specific needs.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <Button
              size="lg"
              className="bg-gray-900 hover:bg-gray-800 text-white px-10 py-6 text-base font-normal rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl group"
              onClick={() => openContactModal(true)}
            >
              Contact Us
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
          </div>

          <p className="text-sm text-gray-500 font-light">
            No commitment required · Free consultation
          </p>
        </div>
      </section>

      <ContactModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)}
        defaultDemo={defaultDemo}
      />
    </>
  );
}
